import { secondAxios } from "../../../../../../api/axios";

// TODO: Need to make api for raci comments
export const getComments = async (raciId) => {
  const response = await secondAxios.get('/raci/comments/' + raciId);
  return response.data;
};

export const createComment = async (comment) => {
  console.log({ comment })
  await secondAxios.post('/raci/comments', comment);
};

export const updateComment = async (comment) => {
  await secondAxios.put(`/comments/${comment.id}`, comment);
};

export const deleteComment = async (commentId) => {
  await secondAxios.delete(`/comments/${commentId}`);
};


export const sendCommentNotification = async (raciId, commentText, userName) => {
  try {
    const emailBody = `A new comment has been added by ${userName}:\n\n"${commentText}"\n\nPlease check the comments section for this document.`;
    
    const response = await secondAxios.post(`/raci/send-email/${raciId}`, {
      body: emailBody,
    });

    if (!response.data.success) {
      throw new Error("Email sending failed");
    }

    return response.data;
  } catch (error) {
    console.error("Error sending comment notification:", error);
    throw error;
  }
};
